import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router, NavigationEnd, RouterOutlet } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';

import { Constants, NO_FOOTER_URLS } from './shared/constants/constants';
import { UtilityService } from './shared/services/utility.service';
import { UserService } from './core/services/user.service';
import { CONTENT } from './modules/login/util/content';

import { HeaderComponent } from './core/header/header.component';
import { NavBarComponent } from './core/nav-bar/nav-bar.component';
import { FooterComponent } from './core/footer/footer.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [HeaderComponent, NavBarComponent, RouterOutlet, FooterComponent]
})
export class AppComponent implements OnInit, OnDestroy {

  content = CONTENT;
  defaultHeaderMode = true;
  noHeaderFooterMode = false;
  noFooterMode = false;
  @ViewChild('timeoutModal') timeoutModal!: TemplateRef<any>;
  currentIdleTime!: string;
  subscriptions: Subscription[] = [];

  constructor(
    private router: Router,
    private title: Title,
    private utilities: UtilityService,
    private userService: UserService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.utilities.getIPAddress();
    this.subscriptions.push(
      this.router.events.subscribe((event: any) => {
        if (event instanceof NavigationEnd) {
          if (event.url.includes('home')) {
            this.title.setTitle(Constants.WELCOME);
          } else if ((event.url.endsWith('provider-reports')) || (event.url.endsWith('search-provider-account')) || (event.url.endsWith('search-provider-record'))) {
            this.title.setTitle(Constants.PROVIDER_REPORTS_TITLE);
          } else if (event.url.includes(Constants.BENEFITS_ROUTE)) {
            this.title.setTitle(Constants.BENEFIT_LOOKUP_TITLE);
          } else {
            this.title.setTitle(Constants.BSC_TITLE);
          }
          if ((event.url.indexOf(Constants.HELP) > -1) ||
            (event.url.indexOf(Constants.SSO_REDIRECTION) > -1) ||
            (event.url.indexOf(Constants.SELF_FUNDED_VIEW_PERMISSIONS_ROUTE) > -1)) {
            this.noHeaderFooterMode = false;
          } else {
            this.noHeaderFooterMode = true;
          }
          if (event.url.includes(Constants.BENEFITS_ROUTE)) {
            this.defaultHeaderMode = false;
          } else {
            this.defaultHeaderMode = true;
          }
          this.noFooterMode = NO_FOOTER_URLS.some(url => event.url.includes(url));
        }
      }),
      this.userService.isTimeOut$.subscribe((data: boolean) => {
        if (data) {
          this.modalService.open(this.timeoutModal, { keyboard: false });
          this.currentIdleTime = this.userService.getCurrentIdleTime;
        }
      })
    );
  }

  /**
   * Method to extend session
   */
  extendSession() {
    this.userService.extendSession();
  }

  // Method to unsubscribe from subscriptions on component destruction
  ngOnDestroy(): void {
    this.subscriptions.forEach((sub: Subscription) => sub.unsubscribe());
  }

}
